import {
  Button,
  TableCell,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { NumericFormat } from 'react-number-format';
import { formatDollarAmount, important } from '../../../utils/global/helper';
import { CustomCheckoutItem } from '../../../types/appointments';

interface Props {
  checkoutItem: CustomCheckoutItem;
  onPriceChange: (price: number) => void;
  isQuantityDisabled?: boolean;
  onQuantityChange?: (quantity: number) => void;
  onRemove?: () => void;
  disabled?: boolean;
}

export default function PricingTableRow({
  checkoutItem,
  onPriceChange,
  isQuantityDisabled = false,
  onQuantityChange,
  onRemove,
  disabled,
}: Props) {
  const theme = useTheme();
  return (
    <TableRow>
      <TableCell style={{ width: '100%', paddingLeft: 0, border: 0 }}>
        <Typography variant="h4">{checkoutItem.name}</Typography>
        <Typography variant="body2">
          {formatDollarAmount(checkoutItem.price)}
        </Typography>
      </TableCell>
      <TableCell sx={{ border: 0 }}>
        <TextField
          disabled={isQuantityDisabled}
          aria-disabled={isQuantityDisabled}
          id="outlined"
          type="number"
          value={checkoutItem.quantity}
          className="table-input"
          InputProps={{ inputProps: { min: 1 } }}
          onChange={e => {
            onQuantityChange?.(parseInt(e.target.value, 10));
          }}
          style={{
            minWidth: 100,
          }}
          sx={{
            '.MuiInputBase-root': {
              height: important('auto'),
            },
          }}
        />
      </TableCell>
      <TableCell sx={{ border: 0 }}>
        <NumericFormat
          thousandSeparator=","
          allowNegative={false}
          decimalScale={2}
          prefix="$"
          value={checkoutItem.price}
          className="table-input"
          onValueChange={val => onPriceChange(val.floatValue ?? 0)}
          disabled={disabled}
          aria-disabled={disabled}
        />
      </TableCell>
      {onRemove && (
        <Button
          sx={{
            marginTop: 3.5,
            padding: 0,
            minWidth: 0,
          }}
          onClick={onRemove}>
          <DeleteIcon htmlColor={theme.palette.outlineGrey.main} />
        </Button>
      )}
    </TableRow>
  );
}
